<template>
    <div class="choose-city" :class="searchCityInfo.bool&&'active'">
        <header>
            <div class="search">
                <div class="search-input">
                    <input
                        type="search"
                        placeholder="搜索城市/行政区"
                        ref="searchInput"
                        v-model="inputValue"
                        v-on:input="debounceSearchInput"
                        v-on:focus="citySearchfocus"
                    />
                </div>
                <div @click="goback">取消</div>
            </div>
            <div v-if="localCity">
                <p>当前城市</p>
                <h3>{{ localCity }}</h3>
            </div>
        </header>
        <main v-show="!searchStatus">
            <div class="history" v-if="history.length">
                <div class="history-nav">
                    <span>最近搜索</span>
                    <span @click="clearHistory"
                        >清空<img
                            src="@/assets/hotel/img/home/clear.png"
                            alt="clear"
                    /></span>
                </div>
                <div class="content">
                    <div
                        v-for="(item, index) of history"
                        :key="index"
                        @click="searchCity(item)"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <div class="hot">
                <div class="hot-nav">热门城市</div>
                <div class="content">
                    <div
                        v-for="(item, index) of hotCity"
                        :key="index"
                        @click="searchCity(item)"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <div class="letterIdx">
                <!-- <div v-for="(item, index) of cityList" :key="index">
                    <div class="letter">{{ item.sort }}</div>
                    <div
                        v-for="(mitem, mindex) of item.list"
                        :key="mindex"
                        @click="searchCity(mitem)"
                    >
                        {{ mitem.name }}
                    </div>
                </div> -->
                <van-index-bar 
					:index-list="indexList"
					highlight-color="#108B30"
					:sticky-offset-top="150"
				>
					<template
						v-for="(item,index) of cityList" 
					>
						<van-index-anchor 
							:index="item.sort"  
							:key="index"
						>
							{{ item.sort }}
						</van-index-anchor>
						<van-cell 
							v-for="(mitem, mindex) of item.list"
							:key="mindex"
							@click="searchCity(mitem)"
							:title="mitem.name" 
						/>
					</template>
                </van-index-bar>
            </div>
        </main>
        <div v-show="searchStatus">
            <div
                class="city-search-name"
                v-for="(item, index) in searchCityList"
                :key="index"
                @click="searchCity(item)"
            >
                {{ item.name }}
            </div>
        </div>
    </div>
</template>

<script>
import { getHotCityData, getHotelSearchCity } from "@/pages/hotel/api";
import { mapState, mapMutations } from "vuex";
import debounce from "@/providers/debounce";
export default {
    data() {
        return {
            hotCity: [], //热门城市
            cityList: [], //城市列表
            history: [], //历史记录
            inputValue: "", //搜索值
            localCity: "", //当前城市
            searchStatus: false, //搜索状态
            debounceSearchInput: null, //正在搜索高频防抖
            searchCityList: [], //搜索返回的城市列表
            indexList: [],
        };
    },
    computed: {
        ...mapState({
            searchCityInfo: (state) => state.hotel.searchCity,
        }),
    },
    mounted() {
		document.body.style.height = "auto";
		document.getElementById('app').style.height = "auto";
        this.inputValue = this.searchCityInfo.name;
        if (this.inputValue == "定位中..." || this.inputValue == "定位失败") {
            this.inputValue = "";
        }
        if (this.searchCityInfo.name.includes("省")) {
            this.localCity = this.searchCityInfo.name
                .split("省")[1]
                .split("市")[0];
        } else if (this.searchCityInfo.name.includes("市")) {
            this.localCity = this.searchCityInfo.name.split("市")[0];
        }

        this.debounceSearchInput = debounce(this.citySearchInput, 500); //函数防抖开始
        this.$refs.searchInput.addEventListener("keypress", (e) => {
            let keycode = e.keyCode;
            if (keycode == "13") {
                e.preventDefault();
                //请求搜索接口
                if (this.inputValue) {
                    this.search({ name: this.inputValue });
                }
            }
        });
        if (localStorage.cityHistory) {
            this.history = JSON.parse(localStorage.cityHistory);
        }
        if (this.searchCityInfo && this.searchCityInfo.bool) {
            this.localCity = this.searchCityInfo.name;
        }
        getHotCityData().then((res) => {
            this.hotCity = res.hot;
            this.cityList = res.city;
            this.indexList = res.city.map((item) => {
                return item.sort;
            });
        });
    },
    methods: {
        ...mapMutations(["setState"]),
        searchCity(obj) {
            //搜索
            if (localStorage.cityHistory) {
                let history = JSON.parse(localStorage.cityHistory);
                let bool = history.some((item) => {
                    return item.name == obj.name;
                });
                if (!bool) {
                    history.unshift(obj);
                    if (history.length > 8) {
                        history.pop();
                    }
                    localStorage.cityHistory = JSON.stringify(history);
                }
            } else {
                localStorage.cityHistory = JSON.stringify([obj]);
            }
            this.setState([
                {
                    name: "searchCity",
                    value: { name: obj.name, value: obj, bool: true },
                },
            ]);
            this.goback();
        },
        clearHistory() {
            //清空搜索框
            this.history = [];
            localStorage.removeItem("cityHistory");
        },
        //城市搜索框的聚焦事件
        citySearchfocus() {
            this.searchStatus = true;
        },
        citySearchInput(e) {
            if (this.inputValue != "") {
                getHotelSearchCity(this.inputValue).then((res) => {
                    this.searchCityList = res.list;
                });
            }
        },
        goback() {
            // if(this.searchStatus){
            //     if (localStorage.cityHistory) {
            //         this.history = JSON.parse(localStorage.cityHistory);
            //     }
            //     this.searchStatus = false;
            // }else{
            this.go("back");
            // }
        },
        go(path) {
            //跳转
            if (path == "back") {
                history.go(-1);
            } else {
                this.$router.push(path);
            }
        },
    },
	beforeDestroy() {
		document.body.style.height = "100%";
		document.getElementById('app').style.height = "100%";
	}
};
</script>

<style lang="less" >
	html {
		font-size: calc(var(--sizeScale2) * 10px);
	}
</style>
<style lang="less" scope>
.choose-city {
    min-height: 100%;
    background-color: #fbfbfb;
	margin-top: 15.4rem;
	&.active{
		margin-top: 20.1rem;
	}
    header {
        padding: 6.4rem 2rem 1.5rem 2rem;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background-color: #fbfbfb;
        z-index: 10;
        .search {
            display: flex;
            justify-content: space-between;
            margin-bottom: 3rem;
            .search-input {
                width: 28.3rem;
                height: 4.5rem;
                input {
                    width: 100%;
                    height: 100%;
                    border: none;
                    border-radius: 2.25rem;
                    outline: none;
                    -webkit-appearance: none;
                    box-shadow: 0 0.5rem 1rem 0 rgba(19, 19, 19, 0.07);
                    padding: 0 2rem;
                    font-size: 1.6rem;
                    &::placeholder {
                        font-size: 1.6rem;
                        color: #cccccc;
                        line-height: 2.2rem;
                    }
                }
            }
            > div:nth-of-type(2) {
                flex: 1;
                font-size: 1.6rem;
                font-weight: 400;
                color: #333333;
                text-align: right;
                line-height: 4.5rem;
            }
        }
        > div:nth-of-type(2) {
            font-weight: 500;
            color: #108b30;
            p {
                font-size: 1.4rem;
                line-height: 2rem;
                margin-bottom: 0.5rem;
            }
            h3 {
                font-size: 1.6rem;
                line-height: 2.2rem;
                margin: 0;
            }
        }
    }
    main {
        padding-top: 1.5rem;
        .history {
            .history-nav {
                display: flex;
                justify-content: space-between;
                padding: 0 2rem;
                color: #999999;
                span {
                    &:nth-of-type(1) {
                        font-size: 1.4rem;
                        line-height: 2rem;
                    }
                    &:nth-of-type(2) {
                        display: inline-flex;
                        align-items: center;
                        font-size: 1.2rem;
                        img {
                            width: 1.5rem;
                            height: 1.5rem;
                            // vertical-align: middle;
                            margin-left: 0.5rem;
                        }
                    }
                }
            }
        }
        .hot {
            margin-top: 1rem;
            .hot-nav {
                font-size: 1.4rem;
                line-height: 2rem;
                color: #999999;
                padding: 0 2rem;
            }
        }
        .content {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 2rem;
            &::after {
                content: "";
                width: 10rem;
            }
            > div {
                width: 10rem;
                height: 3.6rem;
                line-height: 3.6rem;
                text-align: center;
                border-radius: 0.5rem;
                background-color: #eeeeee;
                font-size: 1.4rem;
                font-weight: 500;
                color: #333333;
                &:not(:nth-last-child(-n + 3)) {
                    margin-bottom: 1rem;
                }
            }
        }
        .letterIdx {
            padding: 0 2rem;
            div {
                .van-index-anchor {
                    font-weight: 400;
					padding: 0;
					line-height: 2rem;
					margin-bottom: 2rem;
                    color: #999999;
                }
                .van-cell {
                    font-size: 1.4rem;
                    line-height: 2rem;
                    color: #333333;
                    font-weight: 500;
                    margin-bottom: 2rem;
					background:transparent;
					padding: 0;
					&::after{
						display: none;
					}
                }
            }
			.van-index-anchor--sticky{
				background-color: #fbfbfb;
			}
			.van-index-bar__sidebar{
				.van-index-bar__index{
					color: #999999;
				}
			}
        }
    }
}
.city-search-name {
    height: 2.2rem;
    font-size: 1.6rem;
    font-weight: 400;
    color: #333333;
    line-height: 2.2rem;
    padding: 1.2rem 2.5rem;
    position: relative;
    &::before {
        width: calc(100% - 5rem);
        content: "";
        height: 1px;
        background: #eeeeee;
        position: absolute;
        bottom: 0;
    }
}
</style>